// extracted by mini-css-extract-plugin
export var bottomRightDock = "_2g-0";